import fileSys from "../../fileoprators/fileSystem";
import SettingsOprator from "../settingsoprator";
import { COLORBARSHOW } from "../consts";
const DEFAULTSET = COLORBARSHOW;
class ColorBarShown extends SettingsOprator {
  constructor() {
    super(fileSys.getTopographyCfgPath("colorBarShown.json"), DEFAULTSET);
  }
  getColorBarShownSettings() {
    return this.getSettings();
  }
  saveColorBarShownSettings(settings) {
    this.saveSettings(settings);
  }
}
export default ColorBarShown;



// WEBPACK FOOTER //
// ./src/settings/topography/colorBarShown.js